import { useEffect, useState } from 'react';

/**
 * The value, held back until it stops changing for `delay` ms.
 *
 * Used to keep a type-ahead from firing a request per keystroke: the input
 * stays controlled and instant, while the query key it feeds only moves once
 * the user pauses. 250ms is below the threshold where a search box starts to
 * feel unresponsive and above the interval between keystrokes.
 */
export const useDebounce = <T>(value: T, delay = 250): T => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
};

export default useDebounce;
